import { $api } from "../generated/client";

export default function useReturnRequestsOnce({
	shopId,
	search,
}: {
	shopId: string;
	search?: string;
}) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/return-requests/scan",
		{
			params: { path: { shopId }, query: { search: search || "noop" } },
		},
		{
			enabled: !!search?.length,
			retry: false,
			retryOnMount: false,
			refetchOnMount: false,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
		},
	);
}
